import { useVerify } from '@entities/Authentication/model.ts';
import cn from 'classnames';
import { memo } from 'react';
import OtpInput from 'react-otp-input';
import * as st from '@pages/personal/client/editor-page/Modals/styles.module.scss';
import { CommonButton, MediumHeader, TextButton } from '@shared/ui/index.ts';
import { ModalMiddle } from '@src/library/components/common/index.ts';
import { ModalError } from '@src/modules/Authentication/frames/modal-error/index.tsx';
import * as passcodeStyles from '@src/modules/Authentication/InputsControlled/PasscodeControlled/styles.module.scss';
import Timer from '@src/modules/Authentication/Timer/ui.tsx';

type PT = {
  isOpen?: boolean;
  onModalClose: () => void;
  title?: string;
  text: string;
  additionalText?: string;
  passCode: string;
  setPassCode: (newPassCode: string) => void;
  repeatButtonText: string;
  cleanErrorMessage: () => void;
  errorMessage: string;
  showTimer: boolean;
  setShowTimerFalse: () => void;
  onRepeatButtonClick: () => void;
  onReadyButtonClick: () => void;
};

export const CodeModal = memo(
  ({
    passCode,
    setPassCode,
    repeatButtonText,
    text,
    additionalText,
    title,
    onModalClose,
    cleanErrorMessage,
    onReadyButtonClick,
    onRepeatButtonClick,
    setShowTimerFalse,
    showTimer,
    errorMessage,
    isOpen,
  }: PT) => {
    const { isCheckVerificationLoading, isVerificationLoading } = useVerify();
    return (
      <ModalMiddle isOpen={isOpen || false} className={st.modal}>
        <MediumHeader onClose={onModalClose} title={title} middleClassName={st.title} />
        <form className={st.form}>
          <div className={passcodeStyles.passcode}>
            <OtpInput
              value={passCode}
              onChange={(val) => {
                setPassCode(val);
                errorMessage && cleanErrorMessage();
              }}
              renderInput={(props) => (
                <input
                  tabIndex={0}
                  {...props}
                  className={cn(
                    passcodeStyles.passcode__input,
                    errorMessage && passcodeStyles.passcode__error
                  )}
                />
              )}
            />
          </div>

          <section className={st.text}>
            <p>{text}</p>
            {additionalText && <p>{additionalText}</p>}
          </section>

          {showTimer ? (
            <Timer timeout={60000} callback={setShowTimerFalse} />
          ) : (
            <section className={st.control}>
              <TextButton
                type={'button'}
                onClick={onRepeatButtonClick}
                disabled={isVerificationLoading}
              >
                {repeatButtonText}
              </TextButton>
            </section>
          )}
          {errorMessage ? (
            <ModalError className={st.error} error={errorMessage} />
          ) : (
            <CommonButton
              type={'button'}
              onClick={onReadyButtonClick}
              className={st.button}
              disabled={isCheckVerificationLoading}
            >
              Готово
            </CommonButton>
          )}
        </form>
      </ModalMiddle>
    );
  }
);
